import {Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import {ActivatedRoute, Router, Params} from '@angular/router';
import {TableReactiveUrlController} from '@amlCore/tableReactive';
import {RegistriesService} from '../../service';
import {AccessJson, BounceFilter} from '@amlCore/models';
import {CheckDictEnum, RegistriesAccessEnum} from '@amlCore/enums';
import {TableService, UserService, VisitedService} from '@amlCore/services';
import {AlertPanelComponent, AlertService} from '@amlCore/components';
import {BounceAcceptedList} from '../../model';
import {Utils} from '@amlCore/utils';
import { forkJoin } from 'rxjs';


@Component({
  selector: 'app-registry-bounce-register-accepted-list',
  templateUrl: './bounceRegisterAcceptedList.component.html'
})
export class BounceRegisterAcceptedListComponent extends TableReactiveUrlController implements OnInit, OnDestroy {

  isShowVisited = true;
  public isAll = false;
  public loadCheckList = {};
  @ViewChild('alertObjCheck', {static: false}) alertObjToCheck: AlertPanelComponent;

  constructor(private readonly regSrv: RegistriesService,
              protected readonly activatedRoute: ActivatedRoute,
              protected readonly visitedService: VisitedService,
              private readonly alertSrv: AlertService,
              protected readonly tableService: TableService,
              protected readonly router: Router,
              protected readonly userSrv: UserService) {
    super(router, activatedRoute, visitedService, tableService, {sort: 'date', dir: 'DESC'});
  }

  public dataList: BounceAcceptedList[] = [];
  public access: AccessJson;

  ngOnInit() {
    this.access = this.userSrv.getAccess(RegistriesAccessEnum.QREF_OTKAZ);
    this.activatedRoute.queryParams.subscribe(data => {
      this.loadList(this.syncParams(data));
    });
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  public getFilterObject(data: BounceFilter) {
    const filter = this.tableService.getFilterSubject(data);
    return this.getFilterPlanObject(filter);
  }

  public onPageChange(params: BounceFilter) {
    this.navigate(this.getParams({...params, ...this.filter}));
  }

  // @override
  public onSearch() {
    this.customSearch();
  }

  // @override
  public onFilter() {
    this.customSearch();
  }

  public showInfList(item: BounceAcceptedList) {
    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigate(['registries/bounceRegisterList', item.id]);
  }

  public remove($event, item: BounceAcceptedList) {
    this.alertSrv.clear();
    this.regSrv.deleteFile(`/api/v1/cls/refusal/${item.id}`).subscribe(data => {
      this.alertSrv.success(`Запись ${item.filename} удалена!`);
      this.loadList();
    });
  }

  public loadList(params?: BounceFilter) {
    const queryParams = this.getParams(params);
    const $bounceFullInfoList = this.regSrv.getBounceFullInfoList(queryParams);
    const $bounceFullInfoChecksList = this.regSrv.getBounceFullInfoChecksList();
    const $mergedList = forkJoin([$bounceFullInfoList, $bounceFullInfoChecksList]);

    $mergedList.subscribe(data => {
      let infoList = data[0];
      let infoChecksList = data[1];
      infoList?.content?.map((element => {
        infoChecksList.content.forEach(el => {
          if(el.id === element.id) {
            element.checkDate = el.checkDate;
            element.checkResult = el.checkResult;
          }
        })
      }))
      this.dataList = infoList.content;
      this.total = infoList.totalSize;
      this.scrollRun();
    })
  }

  /**
   * Проверка по факторам риска
   * @param item - элемент проверки
   */
  public checkRiskFactor(item: BounceAcceptedList) {
    this.regSrv.doCheckRiskFactor(item, CheckDictEnum.OTKAZ, this.loadCheckList, this.alertObjToCheck);
  }

  private customSearch() {
    const params = this.getSearchPage(this.filter);
    params['sort'] = 'name';
    params['dir'] = 'ASC';
    params['isAll'] = true;
    const urlParam = {};
    for (const key in params) {
      if (params[key] || typeof params[key] === "number") {
        urlParam[key] = params[key];
      }
    }

    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigate(
      ['registries/bounceRegisterList'],
      {queryParams: {q: Utils.encodeJSONBase64(urlParam)} as Params}
    );
  }

  ngOnDestroy() {
    this.checkScrollOptions();
  }

}
